module.exports = __webpack_public_path__ + "static/img/IMG_20160307_190754.b34b9447.jpg";